import { Loader, LogOutIcon } from "lucide-react";
import { toast } from "sonner";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { authClient } from "@/lib/auth-client";
import { useNavigate } from "@tanstack/react-router";
import { closeWebSocketConnection, queryClient, trpc } from "@/utils/trpc";
import { useQuery } from "@tanstack/react-query";
import type { RouterAppContext } from "@/utils/custom-types";
import { Route as WorkspaceRoute } from "@/routes/$workspaceId/route";

export const UserButton = () => {
	const isLoading = false;
	const navigate = useNavigate();

	const { session } = WorkspaceRoute.useLoaderData();

	// const userData = useQuery(trpc.me.getMe.queryOptions());

	// const user = userData?.data?.user;

	const signOut = async () => {
		await authClient.signOut();
		toast.info("Signed out");
		navigate({ to: "/" });
		queryClient.clear()
		closeWebSocketConnection();
	};

	if (isLoading) {
		return <Loader className="size-4 animate-spin text-muted-foreground" />;
	}

	// if (!userData) {
	// 	return null;
	// }

	return (
		<DropdownMenu modal={false}>
			<DropdownMenuTrigger className="relative outline-none">
				<Avatar className="size-9 rounded-md transition hover:opacity-75">
					<AvatarImage
						className="rounded-md"
						alt={session.user?.name}
						src={session.user?.image || ""}
					/>
					<AvatarFallback className="rounded-md">
						{session.user?.name!.charAt(0).toUpperCase()}
					</AvatarFallback>
				</Avatar>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="center" side="bottom" className="w-60">
				<DropdownMenuItem onClick={signOut} className="h-9">
					<LogOutIcon className="mr-2 size-4" />
					Log out
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};
